export const DELETE_MODAL = {
  TITLE: 'Delete Saved Report',
  CONFIRMATION: 'Are you sure you want to delete the',
  REPORT: 'report?',
  CANCEL: 'Cancel',
  DELETE: 'Delete',
};
